import { render, staticRenderFns } from "./InvoiceTable.vue?vue&type=template&id=366c3a72&scoped=true"
import script from "./InvoiceTable.vue?vue&type=script&lang=js"
export * from "./InvoiceTable.vue?vue&type=script&lang=js"
import style0 from "./InvoiceTable.vue?vue&type=style&index=0&id=366c3a72&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366c3a72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('366c3a72')) {
      api.createRecord('366c3a72', component.options)
    } else {
      api.reload('366c3a72', component.options)
    }
    module.hot.accept("./InvoiceTable.vue?vue&type=template&id=366c3a72&scoped=true", function () {
      api.rerender('366c3a72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/table/InvoiceTable.vue"
export default component.exports